/**
 * Catalog utilities for building URLs and working with catalog filters
 */

import { CatalogFilter } from '../types/navigation';

/**
 * Build a catalog URL from a filter object or string
 */
export function buildCatalogUrl(filter?: CatalogFilter | string): string {
  if (!filter) return '/catalog';

  if (typeof filter === 'string') {
    return filter.startsWith('/') ? filter : `/catalog${filter}`;
  }

  const params = new URLSearchParams();

  // Helper to append filter params (handles arrays)
  const appendFilterParam = (key: string, value: string | string[]) => {
    const values = Array.isArray(value) ? value : [value];
    values.forEach(v => params.append(`filters[${key}]`, v));
  };

  // Handle known filter keys
  if (filter.kind) {
    appendFilterParam('kind', filter.kind);
  }

  if (filter.type) {
    appendFilterParam('type', filter.type);
  }

  if (filter.tag) {
    appendFilterParam('tag', filter.tag);
  }

  // Handle custom filter keys (e.g., metadata.namespace, spec.owner)
  Object.keys(filter).forEach(key => {
    if (!['kind', 'type', 'tag'].includes(key)) {
      const value = filter[key];
      if (value !== undefined && value !== null) {
        appendFilterParam(key, value);
      }
    }
  });

  const queryString = params.toString();
  return queryString ? `/catalog?${queryString}` : '/catalog';
}
